import Image from "next/image";
import Link from "next/link";
import { practicalPassRateByRound } from "@/lib/pass-rate-data";
import { cn } from "@/lib/utils";

/**
 * 홈 대시보드 우측 — 최근 회차 실기 합격률 (JCG-2110, 신규 IA).
 *
 * `pass-rate-data.ts`(SSOT)의 실제 회차별 실기 합격률 마지막 항목을 그대로 노출한다(추정·예상
 * 수치 금지 — 발표된 실측값만). 합격률 추이 페이지로 이동.
 */
export default function ExamReviewCard({
  compact = false,
}: {
  compact?: boolean;
}) {
  const latest =
    practicalPassRateByRound[practicalPassRateByRound.length - 1];
  const rate = latest?.["실기 합격률"];
  const roundName = latest?.name ?? "";

  return (
    <Link
      href="/exam-registration/jeongcheogi-pass-rate"
      className={cn(
        "group relative block overflow-hidden rounded-2xl border border-emerald-200 bg-emerald-50/70 transition-colors hover:bg-emerald-100/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 dark:border-emerald-900 dark:bg-emerald-950/30 dark:hover:bg-emerald-950/50",
        compact ? "h-full p-3" : "p-4",
      )}
    >
      <div className="flex items-center gap-3">
        <Image
          src="/main/eureka_gamza.webp"
          alt=""
          width={44}
          height={44}
          className={cn(
            "shrink-0 object-contain",
            compact ? "h-9 w-9" : "h-11 w-11",
          )}
        />
        <div className="min-w-0">
          <p
            className={cn(
              "font-black tabular-nums text-emerald-700 dark:text-emerald-300",
              compact ? "text-xl" : "text-2xl",
            )}
          >
            {typeof rate === "number" ? `${rate}%` : "—"}
          </p>
          <p className="text-[11px] font-medium text-emerald-700/80 dark:text-emerald-400/80">
            {roundName} 실기 합격률
          </p>
        </div>
      </div>
      <p
        className={cn(
          "text-xs text-emerald-800/80 group-hover:underline dark:text-emerald-200/70",
          compact ? "mt-2 leading-snug" : "mt-3",
        )}
      >
        회차별 합격률 추이 보러가기 →
      </p>
    </Link>
  );
}
